export default "__VITE_ASSET__CxfBf_GM__"